module.exports = __webpack_public_path__ + "img/rank_8.33ecb68.png";